export type Video = {
  id: string;
  videoId: string;
  url: string;
  originUrl: string | null;
  previewUrl: string | null;
  coverImageUrl: string | null;
  variants: {type: string; url: string}[] | null;
};
